import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
export function WhyUs() {
  const {
    t
  } = useLanguage();
  const reasons = t('whyUs.reasons') || [];
  return <section id="why-us" className="py-24 md:py-32 bg-white border-t border-black/5" data-id="element-188">
      <div className="container mx-auto px-6 md:px-12" data-id="element-189">
        <div className="max-w-4xl mx-auto" data-id="element-190">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="text-center mb-16" data-id="element-191">
            <p className="text-xs font-semibold tracking-[0.3em] text-gold uppercase mb-4" data-id="element-192">
              {t('whyUs.eyebrow')}
            </p>
            <h2 className="text-3xl md:text-4xl font-heading font-light text-[#0A0A0A]" data-id="element-193">
              {t('whyUs.heading')}
            </h2>
          </motion.div>

          <div className="space-y-6" data-id="element-194">
            {reasons.map((reason: string, index: number) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-center gap-6 p-6 border border-black/5 hover:border-gold/30 transition-colors bg-white" data-id="element-195">
                <div className="flex-shrink-0 w-8 h-8 rounded-full border border-gold flex items-center justify-center" data-id="element-196">
                  <Check className="w-4 h-4 text-gold" strokeWidth={1.5} data-id="element-197" />
                </div>
                <p className="text-lg text-[#0A0A0A] font-light" data-id="element-198">{reason}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}